// extracted by mini-css-extract-plugin
export default {"sort-icons":"SortIcon_sort-icons__PKhls","sort-icon":"SortIcon_sort-icon__rS1bg","sort-icon-active":"SortIcon_sort-icon-active__vLGqt"};